import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {IntegracaoOpendeliveryService} from "../../services/integracaoopendelivery.service";


@Component({
  selector: 'app-cad-integracao-opendelivery-logistica',
  templateUrl: './cad-integracao-opendelivery-logistica.component.html',
  styleUrls: ['./cad-integracao-opendelivery-logistica.component.scss']
})
export class CadIntegracaoOpendeliveryLogisticaComponent implements OnInit {
  @Input() empresa: any = {};
  @ViewChild('frm', {}) frm:  any;
  integracao: any = { veiculoPadrao:  {}, notificarRetirada: true, notificarConclusao: true, retornarNaLoja: true};
  integracaoOpendelivery: any = { }
  salvando = false;
  processando = false;
  removendo = false;
  mensagemErro: string;
  mensagemErroTesteAutenticacao: string;
  mensagemTesteAutenticacao: string;
  testandoAutenticacao = false;
  autenticacaoValidada = false;
  mensagemErroTesteApi: string;
  mensagemTesteApi: string;
  testandoApi = false;
  statusTesteLogistica: number;
  modoCadastroParceiro: 'escolha' | 'conhecido' | 'novo' | 'configurado' = 'escolha';
  parceirosConhecidos: any[] = [];
  parceiroConhecidoSelecionado: any;
  carregandoParceirosConhecidos = false;
  mensagemErroParceirosConhecidos: string;
  gerandoChaves = false;
  textoCopiado: string
  veiculosTipos: any = ["MOTORBIKE_BAG", "MOTORBIKE_BOX", "CAR" , "BICYCLE" , "SCOOTER" , "VUC"];
  conteiners: any = ["NORMAL", "THERMIC"];
  conteinersTamanhos: any = ["SMALL", "MEDIUM" , "LARGE" , "EXTRA_LARGE"];
  urlBaseAutenticacaoPattern = /^(?!.*auth\/token\/?\s*$).*$/i;
  urlBaseApiPattern = /^(?!.*logistics\/delivery\/?\s*$).*$/i;
  constructor(private integracaoOpendeliveryService: IntegracaoOpendeliveryService) {

  }

  obtenhaBaseUrl(){
    return String(`https://${location.host}/opendelivery/hooks/deliveryEvent`)
  }

  ngOnInit(): void {
    if(this.empresa.integracaoOpendeliveryLogistica){
      this.integracao = this.empresa.integracaoOpendeliveryLogistica;
      this.integracao.veiculoPadrao = this.integracao.veiculoPadrao ? JSON.parse(this.integracao.veiculoPadrao) : {}
      if(this.integracao.id){
        this.modoCadastroParceiro = 'configurado';
        this.autenticacaoValidada = !!this.integracao.baseUrl;
      }
    }

    this.integracaoOpendelivery = this.empresa.integracaoOpendelivery;

    if(this.integracaoOpendelivery &&  this.integracaoOpendelivery.merchantId)
      this.integracao.merchantId = this.integracaoOpendelivery.merchantId
    else if(!this.integracao.merchantId){
      fetch(`/opendelivery/merchant/id/gere`)
        .then(res => res.json())
        .then(merchantId => {
          this.integracao.merchantId = merchantId;
        });
    }
  }


  onSubmit(){
    delete this.mensagemErro;

    if(!this.autenticacaoValidada){
      this.mensagemErro = 'Teste a autenticação antes de salvar a integração.';
      return;
    }

    if (this.frm.valid) {
      this.salvando = true;
      this.integracaoOpendeliveryService.salveParametrizacaoLogistica(this.integracao).then((integracao) => {
        this.integracao = this.empresa.integracaoOpendeliveryLogistica = integracao;
        this.modoCadastroParceiro = 'configurado';
        this.parceiroConhecidoSelecionado = null;
        this.salvando = false;
      }).catch((err) => {
        this.salvando = false;
        this.mensagemErro = err;
      })
    } else {
      this.mensagemErro = 'Verifique os campos obrigatorios'
    }
  }

  deveExibirEscolhaInicialParceiro(): boolean {
    return !this.integracao.id && this.modoCadastroParceiro === 'escolha';
  }

  deveExibirListaParceirosConhecidos(): boolean {
    return !this.integracao.id && this.modoCadastroParceiro === 'conhecido' &&
      !this.parceiroConhecidoSelecionado;
  }

  deveExibirFormularioParceiro(): boolean {
    return !!this.integracao.id || this.modoCadastroParceiro === 'novo' ||
      !!this.parceiroConhecidoSelecionado;
  }

  useParceiroConhecido(){
    this.modoCadastroParceiro = 'conhecido';
    delete this.mensagemErroParceirosConhecidos;
    if(this.parceirosConhecidos.length)
      return;

    this.carregandoParceirosConhecidos = true;
    this.integracaoOpendeliveryService.listeParceirosConhecidosLogistica().then((parceiros: any[]) => {
      this.parceirosConhecidos = parceiros || [];
      this.carregandoParceirosConhecidos = false;
    }).catch((erro) => {
      this.mensagemErroParceirosConhecidos = erro;
      this.carregandoParceirosConhecidos = false;
    });
  }

  cadastreNovoParceiro(){
    this.limpeDadosDoParceiro();
    this.modoCadastroParceiro = 'novo';
  }

  selecioneParceiroConhecido(parceiro: any){
    this.limpeDadosDoParceiro();
    this.parceiroConhecidoSelecionado = parceiro;
    this.integracao.authUrl = parceiro.authUrl;
    this.integracao.baseUrl = parceiro.baseUrl;
    this.integracao.appid = parceiro.appid;
  }

  volteParaEscolhaDoParceiro(){
    this.limpeDadosDoParceiro();
    this.modoCadastroParceiro = 'escolha';
  }

  nomeParceiroConhecido(parceiro: any): string {
    try {
      return new URL(parceiro.baseUrl || parceiro.authUrl).hostname;
    } catch (_erro) {
      return parceiro.baseUrl || parceiro.authUrl || parceiro.appid;
    }
  }

  private limpeDadosDoParceiro(){
    this.integracao.authUrl = null;
    this.integracao.baseUrl = null;
    this.integracao.clientId = null;
    this.integracao.clientSecret = null;
    this.integracao.appid = null;
    delete this.integracao.token;
    delete this.integracao.tokenDataExpiracao;
    this.parceiroConhecidoSelecionado = null;
    this.autenticacaoAlterada();
    delete this.mensagemErroParceirosConhecidos;
  }

  autenticacaoAlterada(){
    this.autenticacaoValidada = false;
    delete this.mensagemErroTesteAutenticacao;
    delete this.mensagemTesteAutenticacao;
    delete this.mensagemErroTesteApi;
    delete this.mensagemTesteApi;
    delete this.statusTesteLogistica;
  }

  apiAlterada(){
    delete this.mensagemErroTesteApi;
    delete this.mensagemTesteApi;
    delete this.statusTesteLogistica;
  }

  testeAutenticacao(){
    delete this.mensagemErro;
    delete this.mensagemErroTesteAutenticacao;
    delete this.mensagemTesteAutenticacao;
    delete this.mensagemErroTesteApi;
    delete this.mensagemTesteApi;
    delete this.statusTesteLogistica;
    this.autenticacaoValidada = false;
    this.testandoAutenticacao = true;

    this.integracaoOpendeliveryService.testeAutenticacaoLogistica(this.integracao).then((resultado: any) => {
      this.mensagemTesteAutenticacao = resultado.mensagem;
      this.autenticacaoValidada = true;
      this.testandoAutenticacao = false;
    }).catch((erro) => {
      this.mensagemErroTesteAutenticacao = erro;
      this.testandoAutenticacao = false;
    });
  }

  testeApiLogistica(){
    if(!this.autenticacaoValidada)
      return;

    delete this.mensagemErro;
    delete this.mensagemErroTesteApi;
    delete this.mensagemTesteApi;
    delete this.statusTesteLogistica;
    this.testandoApi = true;

    this.integracaoOpendeliveryService.testeApiLogistica(this.integracao).then((resultado: any) => {
      this.mensagemTesteApi = resultado.mensagem;
      this.statusTesteLogistica = resultado.statusLogistica;
      this.testandoApi = false;
    }).catch((erro) => {
      this.mensagemErroTesteApi = erro;
      this.testandoApi = false;
    });
  }

  desativeIntegracao(){
    this.processando = true;

    this.integracaoOpendeliveryService.desativeIntegracaoLogisca(this.integracao).then((integracao) => {
      this.integracao.ativa = false;
      this.processando = false;
    }).catch((err) => {
      this.processando = false;
      this.mensagemErro = err;
    })

  }

  ativeIntegracao(){
    this.processando = true;

    this.integracaoOpendeliveryService.ativeIntegracaoLogistica(this.integracao).then((integracao) => {
      this.integracao.ativa = true;
      this.processando = false;
    }).catch((err) => {
      this.processando = false;
      this.mensagemErro = err;
    })
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.textoCopiado = val;
  }

}
